/// A normalized device hardware, suitable for use by the application
export var NormalizedDeviceHardware;
(function (NormalizedDeviceHardware) {
    //Mobile gateway / GPS tracker
    NormalizedDeviceHardware["Argo"] = "hardware-argo";
    //Asset tag
    NormalizedDeviceHardware["Juno"] = "hardware-juno";
    //Mesh anchor
    NormalizedDeviceHardware["Meridian"] = "hardware-meridian";
    //Safety wearable
    NormalizedDeviceHardware["Pisces"] = "hardware-pisces";
})(NormalizedDeviceHardware || (NormalizedDeviceHardware = {}));
//# sourceMappingURL=device-hardware.js.map